import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import * as React from 'react';
import {
    Detail,
    TextDetailPart,
    CustomDetailPart,
    isCustomDetailPart,
    isTextDetailPart,
    ButtonDetailPart,
} from '../schema/DetailPart';

const styles = require('./AgendaEventDetailViews.scss');
const classNames = require('classnames/bind');

export const DetailPartView = function DetailPartView(detailPart: Detail) {
    if (isTextDetailPart(detailPart)) {
        return <TextDetailPartView {...detailPart} />;
    }
    if (isCustomDetailPart(detailPart)) {
        return <CustomDetailPartView {...detailPart} />;
    }
    return null;
};

const TextDetailPartView = function TextDetailPartView(props: TextDetailPart) {
    const { colorScheme, getText, className } = props;

    return (
        <div
            style={{
                color: colorScheme ? colorScheme.accessibleText.msColorWhiteBackground : null,
            }}
            title={getText()}
            className={classNames(styles.detail, className)}>
            {getText()}
        </div>
    );
};

const CustomDetailPartView = function CustomDetailPartView(props: CustomDetailPart) {
    return props.renderCustomDetailPart ? props.renderCustomDetailPart() : null;
};

export const ButtonPartView = function ButtonPartView(props: ButtonDetailPart) {
    const { colorScheme, buttonProps } = props;
    const textColor = colorScheme
        ? colorScheme.accessibleText.msColorWhiteBackground + '!important'
        : null;
    return (
        <DefaultButton
            {...buttonProps}
            className={styles.button}
            styles={{
                root: {
                    color: textColor,
                },
                textContainer: styles.buttonText,
                label: styles.buttonLabel,
            }}
        />
    );
};
